import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';


@Component({
  selector: 'app-firm-capacity-assessment',
  standalone: false,
  templateUrl: './firm-capacity-assessment.component.html',
  styleUrl: './firm-capacity-assessment.component.scss'
})
export class FirmCapacityAssessmentComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() id: any
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false
  @Input() stepDetails: any;
  @Input() schemeType: any;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedUrl: any;
  apiUrl = environment.APIUrl
  private subscriptions = new Subscription();
  userID: any;
  allDmsFiles: any[] = [];
  /** Mode of tender from draft-rfp API; hide vendor management when "Open Tender" or "Single Tender" */
  modeOfTender: string | null = null;

  // Firm capacity required flag
  firmCapacityRequired: string = 'yes';

  // Committee properties
  committees: any[] = [];
  schemes: any[] = [];
  selectedScheme: any;
  userList: any;
  committeeForm!: FormGroup;
  assignmentForm!: FormGroup;
  memberCols = [
    { field: 'slNo', header: 'SL Number', filterType: 'text' },
    { field: 'user', header: 'Name of the Member', filterType: 'text' },
    { field: 'designation', header: 'Designation', filterType: 'text' },
    { field: 'role', header: 'Role', filterType: 'text' },
    { field: 'mobile_no', header: 'Mobile No.', filterType: 'text' },
    { field: 'email_id', header: 'Email ID', filterType: 'text' },
    { field: 'landline_no', header: 'Landline No.', filterType: 'text' },
  ];
  addCommitteeDialog = false;
  addNewCommitteeDialog = false;
  updateCommitteDialog = false;
  selectedCommittee: any;
  editMemberDialog = false;
  deleteMember = false;
  showDeleteConfirmDialog = false;
  committeeToDelete: any = null;
  committeeDeleteIndex = -1;
  userInputMode: 'dropdown' | 'manual' = 'dropdown';
  committeeID: any;
  memberID: any;
  memberToDeleteId: any;

  constructor(private fb: FormBuilder, private config: PrimeNGConfig,
    private uploadService: UploadService, private messageService: MessageService,
    private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      justification: ['', Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
      if (this.payload?.proposal_id) {
        this.getCommittee();
        this.getUserList();
      }
    });
    this.getRfpDetails();
    this.getFirmCapacityStatus();

    // Committee forms
    this.committeeForm = this.fb.group({
      committeeName: ['', Validators.required],
    });
    this.assignmentForm = this.fb.group({
      user: [null],
      user_name: [''],
      role: ['', Validators.required],
      designation: [''],
      contact_details: [''],
      mobile_no: [''],
      email_id: [''],
      landline_no: [''],
    });
    this.updateFormValidation();
  }

  /**
   * Fetch firm capacity requirement status from technical negotiations step
   */
  getFirmCapacityStatus(): void {
    const proposalId = this.payload.proposal_id;
    const baseUrl =  '/revenue/technical-negotiation/';

    const sub = this.api.getAPI(`${baseUrl}?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
      next: (res: any) => {
        if (res && res.step_capacity) {
          this.firmCapacityRequired = res.step_capacity;
        }
      },
      error: (err) => {
        console.error('Error fetching firm capacity status:', err);
        // Default to 'yes' if there's an error
        this.firmCapacityRequired = 'yes';
      }
    });
    this.subscriptions.add(sub);
  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // this.isEditorDisabled=true;
      // //console.log(this.isEditable , this.stepDetails)
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  rfpdata: any;
  getRfpDetails(): void {
    const proposalId = this.payload.proposal_id;
    const stepId = this.step.id;
    const normalizedScheme = this.schemeType?.toLowerCase().replace(/\s+/g, '');

    let apiUrl = '';

    // if (['makei', 'makeii', 'makeiii'].includes(normalizedScheme)) {
    //   apiUrl = `/make1/pre-eol/?proposal_step=${stepId}&proposal_step__proposal=${proposalId}`;
    // } else {
    apiUrl = `/revenue/capacity/assessment/?proposal_step=${stepId}&proposal_step__proposal=${proposalId}`;

    // }
    // Call API
    const sub = this.api.getAPI(apiUrl).subscribe((res: any) => {
      // Revenue pre-rfp API returns { data: [...], vendor_data: {...}, mode_tendor: "..." }
      if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
        this.rfpdata = res.data[0];
      } else {
        this.rfpdata = res[0];
      }
      this.modeOfTender = res?.mode_tendor ?? null;
      console.log('this data is revenue RFP', this.rfpdata);
      const dmsFiles: DmsFile[] = this.rfpdata?.dms_files ?? [];
      this.allDmsFiles = dmsFiles;
      this.uploadedUrl = this.rfpdata?.mom || this.rfpdata?.file || null;
      this.commentForm.patchValue({
        justification: this.rfpdata?.justification || this.rfpdata?.paragraph || this.rfpdata?.comment || ''

      });
      const queryData = this.rfpdata?.prebid_query || this.rfpdata?.pre_eoi_query || this.rfpdata?.preeolmake_query || [];

    });
    this.subscriptions.add(sub);
  }

  /** True when vendor management (upload vendor files) should be hidden (Open Tender / Single Tender). */
  get hideVendorManagement(): boolean {
    const m = (this.modeOfTender || '').trim();
    return m === 'Open Tender' || m === 'Single Tender' || m === 'Open Tinder';
  }
  editForm() {
    this.commentForm.enable();
    this.messageService.add({ severity: 'info', summary: 'info', detail: 'Form is now editable.' });
  }




  onSubmit(): void {
    const formData = new FormData();
   
    


      formData.append('proposal_step', this.step.id);
      formData.append('comment', this.commentForm.get('justification')?.value || '');


    
    const normalizedScheme = this.schemeType?.toLowerCase().replace(/\s+/g, '');
    const isMakeScheme = ['makei', 'makeii', 'makeiii'].includes(normalizedScheme);

    // Determine base endpoint - Make I uses /make1/pre-eol/, others use existing endpoints
    // const baseUrl = isMakeScheme ? '/make1/pre-eol/' : '/revenue/pre-rfp/meeting/';
    const baseUrl = '/revenue/capacity/assessment/';

    if (this.rfpdata?.id) {
      // Update existing RFP
      const sub = this.api.putAPI(`${baseUrl}${this.rfpdata.id}/`, formData).subscribe({
        next: (res: any) => {
          // Check if response is successful - verify response has id or status indicates success
          const responseData = res?.data || res;
          const isSuccess = responseData && (
            responseData.id ||
            responseData.status === 1 ||
            responseData.status === '1' ||
            (responseData.comment !== undefined) // If comment exists, it's likely successful
          );

          if (isSuccess) {
            if (this.fileUpload) {
              this.fileUpload.clear();
            }
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: responseData.message || res?.message || ' Data updated successfully'
            });
            // Emit routeConfig only after successful API response

          }
        },
        error: (err) => {
          console.error('Error updating pre-rfp-meeting:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save data'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      // Create new RFP
      const sub = this.api.postAPI(baseUrl, formData).subscribe({
        next: (res: any) => {
          // Check if response is successful - verify response has id or status indicates success
          const responseData = res?.data || res;
          const isSuccess = responseData && (
            responseData.id ||
            responseData.status === 1 ||
            responseData.status === '1' ||
            (responseData.comment !== undefined) // If comment exists, it's likely successful
          );

          if (isSuccess) {
            if (this.fileUpload) {
              this.fileUpload.clear();
            }
            this.getRfpDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: responseData.message || res?.message || 'Data uploaded successfully'
            });
            // Emit routeConfig only after successful API response

          }
        },
        error: (err) => {
          console.error('Error saving pre-rfp-meeting:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save data'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }


  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.commentForm.get('justification')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }



  get meetingTitle(): string {
    const normalized = this.schemeType?.toLowerCase().replace(/\s+/g, '');
    let title;
    if (normalized == 'makei' || normalized == 'makeii' || normalized == 'makeiii') {
      title = 'Pre-EOI Meeting'
    } else if (normalized == 'rev' || normalized == 'idex') {
      title = 'RFP Vetting'
    } else {
      title = 'Pre-RFP Meeting';
    }
    return title;
  }

  saveRow(row: any) {
    console.log("Saved Row:", row);
    const normalizedScheme = this.schemeType?.toLowerCase().replace(/\s+/g, '');
    const isMakeScheme = ['makei', 'makeii', 'makeiii'].includes(normalizedScheme);

    // Determine base endpoint for query API
    const queryBaseUrl = isMakeScheme ? '/make1/pre-eol/query/' : '/revenue/pre-rfp/query/';

    let payload = {
      preeol: this.rfpdata.id,
      query: row.query,
      reply: row.reply,
      sequence: row.sequence
    }

    if (row.id) {
      const sub = this.api.putAPI(`${queryBaseUrl}${row.id}/`, payload).subscribe({
        next: (res: any) => {
          this.getRfpDetails();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Query/Reply record updated successfully'
          });
        },
        error: (err) => {
          console.error('Error updating query/reply:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to update query/reply'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(queryBaseUrl, payload).subscribe({
        next: (res: any) => {
          this.getRfpDetails();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Query/Reply record uploaded successfully'
          });
        },
        error: (err) => {
          console.error('Error saving query/reply:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save query/reply'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }

  // Vendor Management Event Handlers
  onVendorAdded(event: any): void {
    console.log('Vendor added:', event);
  }

  onVendorUpdated(event: any): void {
    console.log('Vendor updated:', event);
  }

  onVendorDeleted(event: any): void {
    console.log('Vendor deleted:', event);
  }

  onFilesSubmitted(event: any): void {
    console.log('Files submitted:', event);
  }

  // ---------- Committee ----------
  updateFormValidation(): void {
    if (this.userInputMode === 'dropdown') {
      this.assignmentForm.get('user_name')?.setValue('');
      this.assignmentForm.get('user_name')?.clearValidators();
      this.assignmentForm.get('user_name')?.updateValueAndValidity();
      this.assignmentForm.get('user')?.setValidators(Validators.required);
      this.assignmentForm.get('user')?.updateValueAndValidity();
    } else {
      this.assignmentForm.get('user')?.setValue(null);
      this.assignmentForm.get('user')?.clearValidators();
      this.assignmentForm.get('user')?.updateValueAndValidity();
      this.assignmentForm.get('user_name')?.setValidators(Validators.required);
      this.assignmentForm.get('user_name')?.updateValueAndValidity();
    }
  }

  onUserInputModeChange(): void {
    this.updateFormValidation();
  }

  getCommittee(): void {
    if (!this.payload?.proposal_id) return;
    const sub = this.api
      .getAPI(`/transaction/committee/?proposal=${this.payload.proposal_id}`)
      .subscribe((res: any) => {
        this.api.getAPI(`/master/committee/`).subscribe((masterRes: any) => {
          this.schemes = masterRes.data || [];
        });
        if (res.length === 0) {
          this.committees = [];
        } else {
          this.committees = res;
          this.committees.forEach((committee: any) => {
            if (committee.members && Array.isArray(committee.members)) {
              committee.members = committee.members.map((member: any, index: number) => ({
                ...member,
                slNo: index + 1,
                user: member.user_name || member.user || '',
                designation: member.designation || '',
                mobile_no: member.mobile_no || '',
                email_id: member.email_id || '',
                landline_no: member.landline_no || '',
              }));
            }
          });
        }
      });
    this.subscriptions.add(sub);
  }

  getUserList(): void {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.results?.data || res.data;
    });
    this.subscriptions.add(sub);
  }

  loadSchemeCommittees(event?: any): void {
    if (event?.value) this.selectedScheme = event.value;
    if (!this.selectedScheme) return;
    const committeeId = this.selectedScheme.id || this.selectedScheme.value || this.selectedScheme.committee_id;
    if (!committeeId) return;
    const sub = this.api
      .getAPI(`/master/committee/member/?committee=${committeeId}`)
      .subscribe(() => { });
    this.subscriptions.add(sub);
  }

  openAddNewCommitteeDialog(): void {
    this.committeeForm.reset();
    this.addNewCommitteeDialog = true;
  }

  onCommitteeSubmit(): void {
    if (!this.committeeForm.valid || !this.payload?.proposal_id) return;
    const payload = {
      proposal: this.payload.proposal_id,
      name: this.committeeForm.get('committeeName')?.value?.trim(),
    };
    const sub = this.api.postAPI('/transaction/committee/', payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee added successfully' });
        this.addNewCommitteeDialog = false;
        this.committeeForm.reset();
        this.getCommittee();
      },
      error: (err: any) => {
        const msg = err?.error?.detail || err?.error?.message || 'Failed to add committee.';
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
      },
    });
    this.subscriptions.add(sub);
  }

  addFromExisting(): void {
    if (!this.selectedScheme) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a committee from the dropdown first.' });
      return;
    }
    const committeeId = this.selectedScheme.id || this.selectedScheme.value || this.selectedScheme.committee_id;
    if (!committeeId) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Selected committee is missing required information.' });
      return;
    }
    if (!this.payload?.proposal_id) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Proposal information is not available.' });
      return;
    }
    const committeeName = this.selectedScheme.name || this.selectedScheme.label || this.selectedScheme.committee_name;
    const body = {
      proposal: this.payload.proposal_id,
      name: committeeName,
      committe_master: committeeId,
    };
    const sub = this.api.postAPI('/transaction/committee/', body).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee added successfully' });
        this.selectedScheme = null;
        this.getCommittee();
        this.assignmentForm.reset();
      },
      error: (err: any) => {
        const msg = err?.error?.detail || err?.error?.message || 'Failed to add committee.';
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
      },
    });
    this.subscriptions.add(sub);
  }

  openAddCommittee(committee: any): void {
    this.committeeForm.reset();
    this.assignmentForm.reset();
    this.userInputMode = 'dropdown';
    this.committeeID = committee.id;
    this.updateFormValidation();
    this.addCommitteeDialog = true;
  }

  onAssignmentSubmit(): void {
    if (!this.assignmentForm.valid) return;
    let body: any = {
      committee_id: this.committeeID,
      role: this.assignmentForm.get('role')?.value,
      designation: this.assignmentForm.get('designation')?.value || '',
      contact_details: this.assignmentForm.get('contact_details')?.value || '',
      mobile_no: this.assignmentForm.get('mobile_no')?.value || '',
      email_id: this.assignmentForm.get('email_id')?.value || '',
      landline_no: this.assignmentForm.get('landline_no')?.value || '',
    };
    if (this.userInputMode === 'dropdown' && this.assignmentForm.get('user')?.value) {
      body.user_id = this.assignmentForm.get('user')?.value.id;
    } else if (this.userInputMode === 'manual' && this.assignmentForm.get('user_name')?.value) {
      body.user_name = this.assignmentForm.get('user_name')?.value.trim();
    }
    const sub = this.api.postAPI('/transaction/committee/member/', body).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Member added successfully' });
        this.addCommitteeDialog = false;
        this.getCommittee();
        this.assignmentForm.reset();
        this.userInputMode = 'dropdown';
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save mapping.' });
      },
    });
    this.subscriptions.add(sub);
  }

  updateCommittemeber(member: any, committee: any): void {
    const matchedUser = this.userList?.find((u: any) => u.loginname === member.user);
    const extraFields = {
      designation: member.designation || '',
      contact_details: member.contact_details || '',
      mobile_no: member.mobile_no || '',
      email_id: member.email_id || '',
      landline_no: member.landline_no || '',
    };
    if (matchedUser) {
      this.userInputMode = 'dropdown';
      this.assignmentForm.patchValue({ user: matchedUser, user_name: '', role: member.role, ...extraFields });
    } else {
      this.userInputMode = 'manual';
      this.assignmentForm.patchValue({ user: null, user_name: member.user_name || member.user || '', role: member.role, ...extraFields });
    }
    this.committeeID = committee.id;
    this.memberID = member.id;
    this.editMemberDialog = true;
    this.updateFormValidation();
  }

  onAssignmentUpdateSubmit(): void {
    if (!this.assignmentForm.valid) return;
    let body: any = {
      committee_id: this.committeeID,
      role: this.assignmentForm.get('role')?.value,
      designation: this.assignmentForm.get('designation')?.value || '',
      contact_details: this.assignmentForm.get('contact_details')?.value || '',
      mobile_no: this.assignmentForm.get('mobile_no')?.value || '',
      email_id: this.assignmentForm.get('email_id')?.value || '',
      landline_no: this.assignmentForm.get('landline_no')?.value || '',
    };
    if (this.userInputMode === 'dropdown' && this.assignmentForm.get('user')?.value) {
      body.user_id = this.assignmentForm.get('user')?.value.id;
    } else if (this.userInputMode === 'manual' && this.assignmentForm.get('user_name')?.value) {
      body.user_name = this.assignmentForm.get('user_name')?.value.trim();
    }
    const sub = this.api.putAPI(`/transaction/committee/member/${this.memberID}/`, body).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee member updated successfully' });
        this.getCommittee();
        this.assignmentForm.reset();
        this.userInputMode = 'dropdown';
        this.editMemberDialog = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save mapping.' });
      },
    });
    this.subscriptions.add(sub);
  }

  showDeletePopup(memberRow: any): void {
    this.deleteMember = true;
    this.memberToDeleteId = memberRow.id;
  }

  ConfirmMemberDelete(): void {
    const sub = this.api.deleteAPI(`/transaction/committee/member/${this.memberToDeleteId}/`).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Member Deleted Successfully' });
        this.deleteMember = false;
        this.getCommittee();
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete.' });
      },
    });
    this.subscriptions.add(sub);
  }

  openDeleteDialog(committee: any, index: number): void {
    this.committeeToDelete = committee;
    this.committeeDeleteIndex = index;
    this.showDeleteConfirmDialog = true;
  }

  confirmDeleteCommittee(): void {
    const id = this.committeeToDelete?.id;
    if (id == null) return;
    const sub = this.api.deleteAPI(`/transaction/committee/${id}/`).subscribe({
      next: () => {
        this.committees.splice(this.committeeDeleteIndex, 1);
        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Committee removed successfully.' });
        this.getCommittee();
        this.showDeleteConfirmDialog = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete committee.' });
        this.showDeleteConfirmDialog = false;
      },
    });
    this.subscriptions.add(sub);
  }

  updateCommitte(data: any): void {
    this.updateCommitteDialog = true;
    this.selectedCommittee = data;
    setTimeout(() => {
      this.committeeForm.patchValue({ committeeName: this.selectedCommittee?.name });
    }, 0);
  }

  updateSubmit(): void {
    if (!this.committeeForm.valid || !this.selectedCommittee) return;
    const payload = {
      proposal: this.payload.proposal_id,
      name: this.committeeForm.get('committeeName')?.value,
    };
    const sub = this.api.putAPI(`/transaction/committee/${this.selectedCommittee.id}/`, payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee updated successfully' });
        this.updateCommitteDialog = false;
        this.getCommittee();
        this.committeeForm.reset();
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save.' });
      },
    });
    this.subscriptions.add(sub);
  }
}
